import { useContext } from "react";
import { AppContext } from "@/contexts/app-context";

export const useApp = () => {
  const props = useContext(AppContext);

  return props;
};
